import React from "react";
import { Factory, Workflow, Eye, FolderCheck, SlidersHorizontal, LayoutGrid } from "lucide-react";
import { Reveal, Overline, Stagger, StaggerItem } from "./primitives";

const outcomes = [
  { icon: Factory, stat: "0%", statLabel: "product markups", title: "Factory Direct Buying", desc: "Purchase straight from the manufacturer at true factory pricing." },
  { icon: Workflow, stat: "1", statLabel: "purchase order", title: "Simplified Procurement", desc: "A single PO drives the entire full container operation." },
  { icon: Eye, stat: "100%", statLabel: "milestone visibility", title: "Complete Shipment Visibility", desc: "Track every stage from production to delivery in real time." },
  { icon: FolderCheck, stat: "1", statLabel: "document hub", title: "Centralized Documentation", desc: "Every file organized, versioned and instantly accessible." },
  { icon: SlidersHorizontal, stat: "Full", statLabel: "operational control", title: "Operational Control", desc: "Own every decision across your import operation with clarity." },
  { icon: LayoutGrid, stat: "1", statLabel: "connected Workspace", title: "One Workspace", desc: "Quotes, orders, freight, inspection and shipment — unified." },
];

export const OutcomesSection = () => {
  return (
    <section
      id="outcomes"
      data-testid="outcomes-section"
      className="border-t border-slate-100 bg-slate-50/40 py-24 lg:py-32"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <Reveal className="max-w-2xl">
          <Overline>Business Outcomes</Overline>
          <h2 className="mt-4 font-display text-3xl font-bold tracking-tight text-ink md:text-4xl">
            Measurable results for import teams.
          </h2>
          <p className="mt-4 text-base text-slateink md:text-lg">
            FullContainer™ turns fragmented procurement into a single, controlled operation.
          </p>
        </Reveal>

        <Stagger className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {outcomes.map((o) => (
            <StaggerItem key={o.title}>
              <div className="group h-full rounded-2xl border border-slate-200 bg-white p-7 shadow-card-base transition-all duration-300 hover:-translate-y-1 hover:shadow-card-hover">
                <div className="flex items-center justify-between">
                  <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-demax-soft text-demax">
                    <o.icon className="h-5 w-5" strokeWidth={1.75} />
                  </span>
                </div>
                <div className="mt-5 flex items-baseline gap-2">
                  <span className="font-display text-4xl font-extrabold tracking-tight text-ink">
                    {o.stat}
                  </span>
                  <span className="text-xs font-medium uppercase tracking-wider text-slateink">
                    {o.statLabel}
                  </span>
                </div>
                <h3 className="mt-4 font-display text-lg font-semibold tracking-tight text-ink">
                  {o.title}
                </h3>
                <p className="mt-1.5 text-sm leading-relaxed text-slateink">{o.desc}</p>
              </div>
            </StaggerItem>
          ))}
        </Stagger>
      </div>
    </section>
  );
};
